export const charityNameExtractor = (
  charityName: string
): { name: string; id: string } => {
  const [id, name] = charityName ? charityName.split("_") : ["", ""];
  return {
    name,
    id,
  };
};
